export default __webpack_public_path__ + "static/alert-logic-screen-c08a6048cd70f58e0f2ac767aa330303.png";